module.exports = __webpack_public_path__ + "img/slide-11.f204e6b8.jpg";